import { render } from "./PatientMedicalRecordFileSection.vue?vue&type=template&id=3c69f91e"
import script from "./PatientMedicalRecordFileSection.vue?vue&type=script&lang=js"
export * from "./PatientMedicalRecordFileSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__